<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo},
    data() {
        return {
            email: '',
            phone: '',
            loading: false,
            sent: false,
            //phoneCode: '',
            emailCode: '',
            password: '',
            password_confirmation: '',
            first_name: null,
            last_name: null,
            errors: {}
        }
    },
    methods: {
        back() {
            this.sent = false;
            this.errors = {};
            this.password = '';
            this.password_confirmation = '';
            //this.phoneCode = '';
            this.emailCode = '';
        },
        submit() {
            if (this.sent) {
                this.verify();
            } else {
                this.sendCodes();
            }
        },
        sendCodes() {
            this.loading = true;
            axios.post('/verify-codes', { email: this.email, phone: this.phone }).then((data) => {
                if (data && data.error) {
                    this.error = data.error;
                } else if (data && data?.data?.message) {
                    this.sent = true;
                    this.$toast.success(data.data.message);
                    this.errors = {};
                }
            }).catch((data) => {
                if (data.response?.data?.message) {
                    this.$toast.error(data.response.data.message)
                }
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            });
        },
        verify() {
            this.loading = true;
            axios.post('/verify', {
                email: this.email,
                phone: this.phone,
                email_code: this.emailCode,
                //phone_code: this.phoneCode,
                password: this.password,
                password_confirmation: this.password_confirmation,
                first_name: this.first_name,
                last_name: this.last_name,
            }).then((data) => {
                if (data && data?.data?.message) {
                    this.sent = true;
                    this.$toast.success(data.data.message);
                }
                this.$auth.logout();
                this.$router.push('/login');
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-6-desktop is-6-widescreen">
                        <form @submit.prevent="submit" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.verification.title_label') }}
                            </p>
                            <p class="my-4 px-4">
                                {{ $t('auth.verification.enter_email_and_phone_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <div class="mb-4 pb-4">
                                    <div>
                                        <b-field :label="$t('users.fields.email.name')"
                                                 label-for="email"
                                                 :type="errors.email ? 'is-danger' : null"
                                                 :message="errors.email ? errors.email[0] : null">
                                            <b-input required
                                                     :disabled="sent"
                                                     type="email"
                                                     id="email"
                                                     autofocus
                                                     name="email"
                                                     placeholder="user@example.com"
                                                     v-model="email"
                                                     icon="at"
                                            ></b-input>
                                        </b-field>

                                        <b-field :label="$t('users.fields.phone_number.name')"
                                                 label-for="phone"
                                                 :type="errors.phone ? 'is-danger' : null"
                                                 :message="errors.phone ? errors.phone[0] : null">
                                            <b-input
                                                id="phone"
                                                :disabled="sent"
                                                required
                                                type="text"
                                                name="phone"
                                                placeholder="100200300"
                                                v-model="phone"
                                                icon="phone"
                                            ></b-input>
                                        </b-field>
                                    </div>
                                </div>

                                <div v-if="sent" class="my-4 py-4">
                                    <div>
                                        <b-field :label="$t('auth.verification.fields.email_verification_code.name')"
                                                 label-for="code-email"
                                                 :type="errors.email_code ? 'is-danger' : null"
                                                 :message="errors.email_code ? errors.email_code[0] : $t('auth.verification.fields.email_verification_code.error_message')">
                                            <b-input
                                                id="code-email"
                                                required
                                                type="text"
                                                name="code-email"
                                                placeholder="000000"
                                                v-model="emailCode"
                                                icon="email"
                                            ></b-input>
                                        </b-field>

<!--                                        <b-field label="Kod SMS"
                                                 label-for="code-phone"
                                                 :type="errors.phone_code ? 'is-danger' : null"
                                                 :message="errors.phone_code ? errors.phone_code[0] : null">
                                            <b-input
                                                id="code-phone"
                                                required
                                                type="text"
                                                name="code-phone"
                                                placeholder="000000"
                                                v-model="phoneCode"
                                                icon="cellphone"
                                            ></b-input>
                                        </b-field>-->
                                    </div>

                                    <div class="my-4 py-4">
                                        <b-field :label="$t('auth.fields.password.name')"
                                                 :type="errors.password ? 'is-danger' : null"
                                                 :message="errors.password ? errors.password[0] : null">
                                            <b-input
                                                autocomplete="new-password"
                                                type="password"
                                                placeholder="********"
                                                v-model="password"
                                                icon="lock"
                                            ></b-input>
                                        </b-field>

                                        <b-field :label="$t('auth.fields.password_confirmation.name')"
                                                 :type="errors.password_confirmation ? 'is-danger' : null"
                                                 :message="errors.password_confirmation ? errors.password_confirmation[0] : null">
                                            <b-input
                                                autocomplete="new-password"
                                                type="password"
                                                placeholder="********"
                                                v-model="password_confirmation"
                                                icon="lock"
                                            ></b-input>
                                        </b-field>
                                    </div>

                                    <div class="my-4 py-4" v-if="$auth.user?.first_name === '-' || $auth.user?.last_name === '-'">
                                        <b-field :label="$t('users.fields.first_name.name')"
                                                 label-for="first_name"
                                                 :type="errors.first_name ? 'is-danger' : null"
                                                 :message="errors.first_name ? errors.first_name[0] : null">
                                            <b-input
                                                id="first_name"
                                                required
                                                v-model="first_name"
                                                icon="account"
                                            ></b-input>
                                        </b-field>

                                        <b-field :label="$t('users.fields.last_name.name')"
                                                 label-for="last_name"
                                                 :type="errors.last_name ? 'is-danger' : null"
                                                 :message="errors.last_name ? errors.last_name[0] : null">
                                            <b-input
                                                id="last_name"
                                                required
                                                v-model="last_name"
                                                icon="account"
                                            ></b-input>
                                        </b-field>
                                    </div>
                                </div>

                                <div class="buttons is-centered mt-8 is-flex">
                                    <button v-if="sent" class="button is-dark" @click="back">
                                        {{ $t('actions.back') }}
                                    </button>
                                    <button v-else class="button is-dark" type="button" @click="$router.push({name: 'otc-login'})">
                                        {{ $t('actions.back') }}
                                    </button>
                                    <button class="button is-success is-flex-grow-5" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        <span v-if="sent">{{ $t('actions.save') }}</span>
                                        <span v-else>{{ $t('auth.verification.actions.send_code') }}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
